import type { IObjectSchema } from '@ksyos/koi';
import { DateTime } from '@ksyos/date-time';
import { stringify } from '@common/utils/queryStringUtils';
import { formatDateIntoString } from '@frontend/utils/formatDateIntoString';

export function validateLocationQuery(searchParams: URLSearchParams, validationSchema: IObjectSchema) {
    const params = Object.fromEntries(searchParams);

    const validation = validationSchema.validate(params, {
        stripUnknown: true,
    });

    if (validation.error) {
        return;
    }

    const result = validation.value;

    if (result.startDate) {
        result.startDate = DateTime.from(result.startDate).toDate();
    }

    if (result.endDate) {
        result.endDate = DateTime.from(result.endDate).toDate();
    }

    return result;
}

export function createUrlWithFilterParams(keys: string[], filterObject: Record<string, any>, url: string) {
    const queryParameters: Record<string, any> = {};

    for (const key of keys) {
        const value = filterObject[key as keyof typeof filterObject];
        const formattedValue =
            ['startDate', 'endDate'].includes(key) && typeof value !== 'string' ? formatDateIntoString(value) : value;

        if (value) {
            queryParameters[key] = formattedValue;
        }
    }

    return `${url}${stringify(queryParameters)}`;
}
